import { handleErrorWithSentry, replayIntegration } from '@sentry/sveltekit';
import * as Sentry from '@sentry/sveltekit';

function shouldUseSentry() {
  try {
    const currentUrl = window.location.href;
    return currentUrl.includes('breeze.in');
  } catch (e) {
    return true;
  }
}

const useSentry = shouldUseSentry();

if (useSentry) {
  Sentry.init({
    dsn: 'https://180a8e3b31f479bfb071f51605e542b7@o4507894054453248.ingest.us.sentry.io/4508290549481472',

    tracesSampleRate: 1.0,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // If you don't want to use Session Replay, just remove the line below:
    integrations: [replayIntegration()]
  });
}

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = useSentry ? handleErrorWithSentry() : () => {};
